import {
  GLOBAL_COMMITMENT_DEFAULT_META_TITLE,
  GLOBAL_COMMITMENT_DEFAULT_META_DESCRIPTION,
} from '../../variables';

const createGcMetaData = (
  title,
  metaTitleOverride,
  metaDescriptionOverride
) => {
  const metaTitle = metaTitleOverride
    ? metaTitleOverride
    : `${title} ${GLOBAL_COMMITMENT_DEFAULT_META_TITLE}`;
  const metaDescription = metaDescriptionOverride
    ? metaDescriptionOverride
    : `${title} ${GLOBAL_COMMITMENT_DEFAULT_META_DESCRIPTION}`;
  const socialCardDescription = metaDescriptionOverride
    ? metaDescriptionOverride
    : `${title} ${GLOBAL_COMMITMENT_DEFAULT_META_DESCRIPTION}`;

  return {
    title: metaTitle,
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    socialCardDescription: socialCardDescription,
  };
};

export default createGcMetaData;
